<template>
  <div class="personal" id="content">
    <Row>
      <Col span="5">
        <p style="margin-top: 60px; margin-left: 30px">头像</p>
        <div class="head_img">
          <img :src="uploadList.url" />
        </div>
        <Upload
        :before-upload="beforeUpload"
          :disabled="disabled"
          ref="upload"
          :show-upload-list="false"
          :on-success="handleSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :action="uploadAction"
         
          style="
            display: inline-block;
            width: 58px;
            margin-left: 60px;
            margin-top: 20px;
          "
        >
          <Button icon="ios-share-outline" :disabled="disabled"
            >更换头像</Button
          >
        </Upload>
      </Col>
      <Col span="18" offset="1">
        <Form :model="formItem">
          <h2 style="color: #000">注册</h2>
          <FormItem style="margin-top: 20px">
            <p>姓名<span style="color:red">*</span></p>
            <Input
              v-model="formItem.name"
              style="width: 50%"
              :disabled="disabled"
          /></FormItem>
          <FormItem>
            <p>性别<span style="color:red">*</span></p>
            <RadioGroup
              style="width: 50%"
              v-model="formItem.gender"
              @on-change="gender"
            >
              <Radio label="male" :disabled="disabled">
                <span>男</span>
              </Radio>
              <Radio
                label="female"
                style="margin-left: 40px"
                :disabled="disabled"
              >
                <span>女</span></Radio
              >
            </RadioGroup></FormItem
          >
          <FormItem>
            <p>职称<span style="color:red">*</span></p>
            <!-- <Input
              v-model="formItem.position"
              style="width: 50%"
              :disabled="disabled"
            /> -->
            <Select
            :disabled="disabled"
              v-model="formItem.position"
              placeholder="请选择职称"
              style="width: 50%; text-align: left"
            >
              <Option
                v-for="item in positionList"
                :value="item.value"
                :key="item.label"
                >{{ item.value }}</Option
              >
            </Select>
          </FormItem>
          <FormItem>
            <p>所在省市<span style="color:red">*</span></p>
            <Select
              :disabled="disabled"
              filterable
              v-model="formItem.province"
              placeholder="请选择"
              style="width: 25%"
              @on-change="change"
            >
              <Option
                v-for="item in provinceList"
                :value="item.value"
                :key="item.label"
                >{{ item.value }}</Option
              >
            </Select>
            <Select
              :disabled="disabled"
              filterable
              v-model="formItem.city"
              placeholder="请选择"
              style="width: 24%; margin-left: 1%"
            >
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.label"
                >{{ item.value }}</Option
              >
            </Select>
          </FormItem>
          <FormItem>
            <p>街道地区</p>
            <Input
              v-model="formItem.street"
              style="width: 50%"
              :disabled="disabled"
          /></FormItem>
          <FormItem>
            <p>医院<span style="color:red">*</span></p>
            <Select
              :disabled="disabled"
              filterable
              clearable
              :remote-method="searchHospital"
              v-model="formItem.hospital"
              placeholder="请选择/输入医院"
              style="width: 50%; text-align: left"
              @on-change="getDepartmentDatas"
            >
              <Option
                v-for="item in hospitalList"
                :value="item.OrgName"
                :key="item.ID"
                >{{ item.OrgName }}</Option
              >
            </Select></FormItem
          >
          <FormItem>
            <p>科室<span style="color:red">*</span></p>
            <Select
              :disabled="disabled"
              filterable
              clearable
              v-model="formItem.department"
              placeholder="请选择/输入科室"
              style="width: 50%; text-align: left"
            >
              <Option
                v-for="item in departmentList"
                :value="item.DepartmentName"
                :key="item.ID"
                >{{ item.DepartmentName }}</Option
              >
            </Select>
          </FormItem>
          <FormItem>
            <p>个人简介</p>
            <Input
              :disabled="disabled"
              v-model="formItem.synopsis"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              placeholder="这个人很懒，什么都没留下..."
              style="width: 50%"
          /></FormItem>
          <FormItem>
            <p>擅长</p>
            <Input
              :disabled="disabled"
              v-model="formItem.adept"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              placeholder="这个人很懒，什么都没留下..."
              style="width: 50%"
          /></FormItem>
          <FormItem>
            <p>手机号<span style="color:red">*</span></p>
            <Input
              v-model="formItem.phone"
              style="width: 50%"
              :disabled="disabled"
          /></FormItem>
          <FormItem>
            <p>短信验证码<span style="color:red">*</span></p>
            <div style="width: 100%">
              <Input
                v-model="formItem.code"
                style="width: 35%"
                :disabled="disabled"
              />
              <Button
                :disabled="disabled"
                style="width: 14%; margin-left: 1%"
                type="primary"
                @click="sendCode"
                :loading="loading"
                ><span v-if="ifsendcode">发送验证码&nbsp;</span
                >{{ time }}</Button
              >
            </div>
          </FormItem>
          <FormItem>
            <p>密码<span style="color:red">*</span></p>
            <Input
              :disabled="disabled"
              v-model="formItem.password"
              type="password"
              password
              style="width: 50%"/>
              </FormItem>
          <FormItem>
            <p>确认密码<span style="color:red">*</span></p>
            <Input
              :disabled="disabled"
              style="width: 50%"
              type="password"
              password
              v-model="formItem.repassword"/>
              </FormItem>
          <FormItem>
            <p>医师资格证编码</p>
            <Input
              v-model="formItem.physicians"
              style="width: 50%"
              :disabled="disabled"
          /></FormItem>
          <FormItem label="上传证件:">
            <Row>
              <Col span="12">
                <Row>
                  <Col span="2"
                    ><Upload
                      :disabled="disabled"
                      ref="upload1"
                      :show-upload-list="false"
                      :default-file-list="defaultList1"
                      :on-success="handleSuccess1"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="handleBeforeUpload1"
                      multiple
                      type="drag"
                      :action="uploadAction"
                      style="display: inline-block; width: 104px"
                    >
                      <div
                        style="
                          width: 104px;
                          height: 104px;
                          line-height: 104px;
                          text-align: center;
                        "
                      >
                        <Icon type="ios-add" size="100"></Icon>
                      </div> </Upload
                  ></Col>
                  <Col span="2" offset="3">
                    <div class="physiciansimg" style="position: relative">
                      <img :src="physicianspicture" />
                      <div class="imgbot" @click="showphysicianspicture">
                        示例图<Icon
                          type="ios-search-outline"
                          size="20"
                          style="margin-top: 15px; margin-left: 5px"
                        ></Icon>
                      </div>
                    </div>
                  </Col>
                  <Col
                    span="2"
                    offset="3"
                    v-for="item in physiciansList"
                    :key="item.url"
                  >
                    <div
                      class="physiciansimg"
                      @mouseenter="isRemove1 = true"
                      @mouseleave="isRemove1 = false"
                    >
                      <Poptip
                        :disabled="disabled"
                        confirm
                        title="确定要删除吗？"
                        @on-ok="ok1(item)"
                        @on-cancel="cancel1"
                      >
                        <Icon
                          type="md-close"
                          size="20"
                          style="
                            background: #000;
                            border-radius: 50%;
                            position: absolute;
                            top: -55px;
                            right: -100px;
                            cursor: pointer;
                            opacity: 0.7;
                          "
                          v-show="isRemove1"
                        ></Icon>
                      </Poptip>
                      <img :src="item.url" />
                      <div class="imgbot" @click="showphysicians(item)">
                        看大图<Icon
                          type="ios-search-outline"
                          size="20"
                          style="margin-top: 15px; margin-left: 5px"
                        ></Icon>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <p>职业资格证编码</p>
            <Input
              v-model="formItem.professional"
              style="width: 50%"
              :disabled="disabled"
          /></FormItem>
          <FormItem label="上传证件:">
            <Row>
              <Col span="12">
                <Row>
                  <Col span="2">
                    <Upload
                      :disabled="disabled"
                      ref="upload2"
                      :show-upload-list="false"
                      :default-file-list="defaultList2"
                      :on-success="handleSuccess2"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="handleBeforeUpload2"
                      multiple
                      type="drag"
                      :action="uploadAction"
                      style="display: inline-block; width: 104px"
                    >
                      <div
                        style="
                          width: 104px;
                          height: 104px;
                          line-height: 104px;
                          text-align: center;
                        "
                      >
                        <Icon type="ios-add" size="100"></Icon>
                      </div>
                    </Upload>
                  </Col>
                  <Col span="2" offset="3">
                    <div class="professionalimg" style="position: relative">
                      <img :src="professionalpicture" />
                      <div class="imgbot1" @click="showprofessionalpicture">
                        示例图<Icon
                          type="ios-search-outline"
                          size="20"
                          style="margin-top: 15px; margin-left: 10px"
                        ></Icon>
                      </div>
                    </div>
                  </Col>
                  <Col
                    span="2"
                    offset="3"
                    v-for="item in professionalList"
                    :key="item.url"
                  >
                    <div
                      span="2"
                      class="professionalimg"
                      @mouseenter="isRemove2 = true"
                      @mouseleave="isRemove2 = false"
                    >
                      <Poptip
                        :disabled="disabled"
                        confirm
                        title="确定要删除吗？"
                        @on-ok="ok2(item)"
                        @on-cancel="cancel2"
                      >
                        <Icon
                          type="md-close"
                          size="20"
                          style="
                            position: absolute;
                            right: 0;
                            cursor: pointer;
                            background: #000;
                            border-radius: 50%;
                            top: -55px;
                            right: -100px;
                            opacity: 0.7;
                          "
                          v-show="isRemove2"
                        ></Icon>
                      </Poptip>
                      <img :src="item.url" />
                      <div
                        @click="showprofessional(item)"
                        style="
                          top: 30px;
                          left: 15px;
                          width: 80px;
                          height: 60px;
                          position: absolute;
                          cursor: pointer;
                        "
                      >
                        看大图<Icon type="ios-search-outline" size="20"></Icon>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </FormItem>
          <FormItem style="margin-top: 10px" class="disclaimer">
            <Checkbox v-model="isagreen">阅读并同意<a @click="fullmodal = true">平台知情同意书</a></Checkbox><br/>
            <Button
              type="primary"
              class="submit"
              @click="submit"
              v-if="!disabled"
              :disabled="!isagreen"
              >提交</Button
            >
            <Button
              style="width: 69px; height: 40px; margin-left: 10px;margin-top:20px"
              @click="cancle"
              v-if="!disabled"
              >取消</Button
            ></FormItem>
        </Form>
      </Col>
    </Row>

    <Modal title="查看图片" v-model="visible">
      <img :src="imgName" v-if="visible" style="width: 100%" />
    </Modal>
    <Modal
      v-model="modal1"
      title="选择团队"
      @on-ok="okTeam"
      @on-cancel="cancleTeam"
    >
      <Select
        clearable
        v-model="centerTeam"
        placeholder="请选择团队"
        @on-change="teamChange"
      >
        <Option
          v-for="item in centerTeamList"
          :value="item.Team"
          :key="item.ID"
        >
          {{ item.Team }}
        </Option>
      </Select>
    </Modal>
    <Modal v-model="fullmodal" fullscreen title="平台知情同意书">
        <Pdf></Pdf>
        <div slot="footer">
                <Button @click="okbook('n')">取消</Button>
                <Button type="primary" @click="okbook('y')">同意</Button>
            </div>
    </Modal>
    <div
      v-show="this.isshow"
      style="
        width: 300px;
        height: 300px;
        text-align: center;
        line-height: 300px;
        position: absolute;
        top: 100px;
        right: 150px;
        color:RGB(64,163,255)
      "
    >
      <img src="../assets/u439.png" alt="0.0" style="width: 100%" />
      <p style="color: RGB:(64,163,255);margin-top:-280px">{{ this.status }}</p>
    </div>
  </div>
</template>

<script>
import Request from "../utils/request";
import config from "../config/index.js";
import tools from "../utils/tools.js";
import {
  Row,
  Col,
  Form,
  FormItem,
  Input,
  RadioGroup,
  Radio,
  Upload,
  Button,
  Icon,
  Select,
  Option,
  Modal,
  Poptip,
  Checkbox,
} from "view-design";
import Disclaimer from "../components/disclaimer.vue"
import Pdf from "../components/pdf.vue"
export default {
  components: {
    Row,
    Col,
    Form,
    FormItem,
    Input,
    RadioGroup,
    Radio,
    Upload,
    Button,
    Icon,
    Select,
    Option,
    Modal,
    Poptip,
    Disclaimer,
    Checkbox,
    Pdf,
  },
  data() {
    return {
      fullmodal:false,
      nodutymodal:false,
      uploadAction:config.SXG_baseUrl+"/api/currency/uploadfile",
      picture:"",
      isupload:false,
      imgList1: [],
      imgList2: [],
      status: "",
      disabled: false,
      isshow:false,
      modal1: false, //团队列表的
      centerTeam: "", //团队下拉框的绑定
      centerTeamList: [], //团队下拉框各项的绑定
      centerID: "", //团队的ID
      hospitalList: [], //医院列表
      departmentList: [], //科室列表
      ifsendcode: true, //发送验证码显示字
      cache: {}, //缓存
      physicianspicture:
        "https://www.sino-med.net:444/Applications/494cccf4-2726-4952-a26e-9c1361f2a82e/AppFiles/AnymedStore/2021/03/03/16147619669399354.png",
      professionalpicture:
        "https://www.sino-med.net:444/Applications/494cccf4-2726-4952-a26e-9c1361f2a82e/AppFiles/AnymedStore/2021/03/03/16147619669399354.png",
      loading: false,
      time: "",
      defaultList1: [],
      defaultList2: [],
      isRemove1: false,
      isRemove2: false,
      imgName: "",
      visible: false,
      uploadList: {
        url:
          "https://www.sino-med.net:444/Applications/bcc183de-8a7f-4eda-b46f-419d008795e1/AppFiles/SurgeryPlatform/2021/06/04/16227850825543045.png",
      },
      physiciansList: [],
      professionalList: [],
      cityList: [],
      provinceList: [
        {
          label: "北京市",
          value: "北京市",
        },
        {
          label: "天津市",
          value: "天津市",
        },
        {
          label: "河北省",
          value: "河北省",
          children: [
            {
              prov: "河北省",
              value: "石家庄市",
              label: "石家庄市",
            },
            {
              prov: "河北省",
              value: "唐山市",
              label: "唐山市",
            },
            {
              prov: "河北省",
              value: "秦皇岛市",
              label: "秦皇岛市",
            },
            {
              prov: "河北省",
              value: "邯郸市",
              label: "邯郸市",
            },
            {
              prov: "河北省",
              value: "邢台市",
              label: "邢台市",
            },
            {
              prov: "河北省",
              value: "保定市",
              label: "保定市",
            },
            {
              prov: "河北省",
              value: "张家口市",
              label: "张家口市",
            },
            {
              prov: "河北省",
              value: "承德市",
              label: "承德市",
            },
            {
              prov: "河北省",
              value: "沧州市",
              label: "沧州市",
            },
            {
              prov: "河北省",
              value: "廊坊市",
              label: "廊坊市",
            },
            {
              prov: "河北省",
              value: "衡水市",
              label: "衡水市",
            },
          ],
        },
        {
          label: "山西省",
          value: "山西省",
          children: [
            {
              prov: "山西省",
              value: "太原市",
              label: "太原市",
            },
            {
              prov: "山西省",
              value: "大同市",
              label: "大同市",
            },
            {
              prov: "山西省",
              value: "阳泉市",
              label: "阳泉市",
            },
            {
              prov: "山西省",
              value: "长治市",
              label: "长治市",
            },
            {
              prov: "山西省",
              value: "晋城市",
              label: "晋城市",
            },
            {
              prov: "山西省",
              value: "朔州市",
              label: "朔州市",
            },
            {
              prov: "山西省",
              value: "晋中市",
              label: "晋中市",
            },
            {
              prov: "山西省",
              value: "运城市",
              label: "运城市",
            },
            {
              prov: "山西省",
              value: "忻州市",
              label: "忻州市",
            },
            {
              prov: "山西省",
              value: "临汾市",
              label: "临汾市",
            },
            {
              prov: "山西省",
              value: "吕梁市",
              label: "吕梁市",
            },
          ],
        },
        {
          label: "内蒙古自治区",
          value: "内蒙古自治区",
          children: [
            {
              prov: "内蒙古自治区",
              value: "呼和浩特市",
              label: "呼和浩特市",
            },
            {
              prov: "内蒙古自治区",
              value: "包头市",
              label: "包头市",
            },
            {
              prov: "内蒙古自治区",
              value: "乌海市",
              label: "乌海市",
            },
            {
              prov: "内蒙古自治区",
              value: "赤峰市",
              label: "赤峰市",
            },
            {
              prov: "内蒙古自治区",
              value: "通辽市",
              label: "通辽市",
            },
            {
              prov: "内蒙古自治区",
              value: "鄂尔多斯市",
              label: "鄂尔多斯市",
            },
            {
              prov: "内蒙古自治区",
              value: "呼伦贝尔市",
              label: "呼伦贝尔市",
            },
            {
              prov: "内蒙古自治区",
              value: "巴彦淖尔市",
              label: "巴彦淖尔市",
            },
            {
              prov: "内蒙古自治区",
              value: "乌兰察布市",
              label: "乌兰察布市",
            },
            {
              prov: "内蒙古自治区",
              value: "兴安盟",
              label: "兴安盟",
            },
            {
              prov: "内蒙古自治区",
              value: "锡林郭勒盟",
              label: "锡林郭勒盟",
            },
            {
              prov: "内蒙古自治区",
              value: "阿拉善盟",
              label: "阿拉善盟",
            },
          ],
        },
        {
          label: "辽宁省",
          value: "辽宁省",
          children: [
            {
              prov: "辽宁省",
              value: "沈阳市",
              label: "沈阳市",
            },
            {
              prov: "辽宁省",
              value: "大连市",
              label: "大连市",
            },
            {
              prov: "辽宁省",
              value: "鞍山市",
              label: "鞍山市",
            },
            {
              prov: "辽宁省",
              value: "抚顺市",
              label: "抚顺市",
            },
            {
              prov: "辽宁省",
              value: "本溪市",
              label: "本溪市",
            },
            {
              prov: "辽宁省",
              value: "丹东市",
              label: "丹东市",
            },
            {
              prov: "辽宁省",
              value: "锦州市",
              label: "锦州市",
            },
            {
              prov: "辽宁省",
              value: "营口市",
              label: "营口市",
            },
            {
              prov: "辽宁省",
              value: "阜新市",
              label: "阜新市",
            },
            {
              prov: "辽宁省",
              value: "辽阳市",
              label: "辽阳市",
            },
            {
              prov: "辽宁省",
              value: "盘锦市",
              label: "盘锦市",
            },
            {
              prov: "辽宁省",
              value: "铁岭市",
              label: "铁岭市",
            },
            {
              prov: "辽宁省",
              value: "朝阳市",
              label: "朝阳市",
            },
            {
              prov: "辽宁省",
              value: "葫芦岛市",
              label: "葫芦岛市",
            },
          ],
        },
        {
          label: "吉林省",
          value: "吉林省",
          children: [
            {
              prov: "吉林省",
              value: "长春市",
              label: "长春市",
            },
            {
              prov: "吉林省",
              value: "吉林市",
              label: "吉林市",
            },
            {
              prov: "吉林省",
              value: "四平市",
              label: "四平市",
            },
            {
              prov: "吉林省",
              value: "辽源市",
              label: "辽源市",
            },
            {
              prov: "吉林省",
              value: "通化市",
              label: "通化市",
            },
            {
              prov: "吉林省",
              value: "白山市",
              label: "白山市",
            },
            {
              prov: "吉林省",
              value: "松原市",
              label: "松原市",
            },
            {
              prov: "吉林省",
              value: "白城市",
              label: "白城市",
            },
            {
              prov: "吉林省",
              value: "延边朝鲜族自治州",
              label: "延边朝鲜族自治州",
            },
          ],
        },
        {
          label: "黑龙江省",
          value: "黑龙江省",
          children: [
            {
              prov: "黑龙江省",
              value: "哈尔滨市",
              label: "哈尔滨市",
            },
            {
              prov: "黑龙江省",
              value: "齐齐哈尔市",
              label: "齐齐哈尔市",
            },
            {
              prov: "黑龙江省",
              value: "鸡西市",
              label: "鸡西市",
            },
            {
              prov: "黑龙江省",
              value: "鹤岗市",
              label: "鹤岗市",
            },
            {
              prov: "黑龙江省",
              value: "双鸭山市",
              label: "双鸭山市",
            },
            {
              prov: "黑龙江省",
              value: "大庆市",
              label: "大庆市",
            },
            {
              prov: "黑龙江省",
              value: "伊春市",
              label: "伊春市",
            },
            {
              prov: "黑龙江省",
              value: "佳木斯市",
              label: "佳木斯市",
            },
            {
              prov: "黑龙江省",
              value: "七台河市",
              label: "七台河市",
            },
            {
              prov: "黑龙江省",
              value: "牡丹江市",
              label: "牡丹江市",
            },
            {
              prov: "黑龙江省",
              value: "黑河市",
              label: "黑河市",
            },
            {
              prov: "黑龙江省",
              value: "绥化市",
              label: "绥化市",
            },
            {
              prov: "黑龙江省",
              value: "大兴安岭地区",
              label: "大兴安岭地区",
            },
          ],
        },
        {
          label: "上海市",
          value: "上海市",
          children: [
            {
              prov: "上海市",
              value: "上海市",
              label: "上海市",
            },
          ],
        },
        {
          label: "江苏省",
          value: "江苏省",
          children: [
            {
              prov: "江苏省",
              value: "南京市",
              label: "南京市",
            },
            {
              prov: "江苏省",
              value: "无锡市",
              label: "无锡市",
            },
            {
              prov: "江苏省",
              value: "徐州市",
              label: "徐州市",
            },
            {
              prov: "江苏省",
              value: "常州市",
              label: "常州市",
            },
            {
              prov: "江苏省",
              value: "苏州市",
              label: "苏州市",
            },
            {
              prov: "江苏省",
              value: "南通市",
              label: "南通市",
            },
            {
              prov: "江苏省",
              value: "连云港市",
              label: "连云港市",
            },
            {
              prov: "江苏省",
              value: "淮安市",
              label: "淮安市",
            },
            {
              prov: "江苏省",
              value: "盐城市",
              label: "盐城市",
            },
            {
              prov: "江苏省",
              value: "扬州市",
              label: "扬州市",
            },
            {
              prov: "江苏省",
              value: "镇江市",
              label: "镇江市",
            },
            {
              prov: "江苏省",
              value: "泰州市",
              label: "泰州市",
            },
            {
              prov: "江苏省",
              value: "宿迁市",
              label: "宿迁市",
            },
          ],
        },
        {
          label: "浙江省",
          value: "浙江省",
          children: [
            {
              prov: "浙江省",
              value: "杭州市",
              label: "杭州市",
            },
            {
              prov: "浙江省",
              value: "宁波市",
              label: "宁波市",
            },
            {
              prov: "浙江省",
              value: "温州市",
              label: "温州市",
            },
            {
              prov: "浙江省",
              value: "嘉兴市",
              label: "嘉兴市",
            },
            {
              prov: "浙江省",
              value: "湖州市",
              label: "湖州市",
            },
            {
              prov: "浙江省",
              value: "绍兴市",
              label: "绍兴市",
            },
            {
              prov: "浙江省",
              value: "金华市",
              label: "金华市",
            },
            {
              prov: "浙江省",
              value: "衢州市",
              label: "衢州市",
            },
            {
              prov: "浙江省",
              value: "舟山市",
              label: "舟山市",
            },
            {
              prov: "浙江省",
              value: "台州市",
              label: "台州市",
            },
            {
              prov: "浙江省",
              value: "丽水市",
              label: "丽水市",
            },
          ],
        },
        {
          label: "安徽省",
          value: "安徽省",
          children: [
            {
              prov: "安徽省",
              value: "合肥市",
              label: "合肥市",
            },
            {
              prov: "安徽省",
              value: "芜湖市",
              label: "芜湖市",
            },
            {
              prov: "安徽省",
              value: "蚌埠市",
              label: "蚌埠市",
            },
            {
              prov: "安徽省",
              value: "淮南市",
              label: "淮南市",
            },
            {
              prov: "安徽省",
              value: "马鞍山市",
              label: "马鞍山市",
            },
            {
              prov: "安徽省",
              value: "淮北市",
              label: "淮北市",
            },
            {
              prov: "安徽省",
              value: "铜陵市",
              label: "铜陵市",
            },
            {
              prov: "安徽省",
              value: "安庆市",
              label: "安庆市",
            },
            {
              prov: "安徽省",
              value: "黄山市",
              label: "黄山市",
            },
            {
              prov: "安徽省",
              value: "滁州市",
              label: "滁州市",
            },
            {
              prov: "安徽省",
              value: "阜阳市",
              label: "阜阳市",
            },
            {
              prov: "安徽省",
              value: "宿州市",
              label: "宿州市",
            },
            {
              prov: "安徽省",
              value: "六安市",
              label: "六安市",
            },
            {
              prov: "安徽省",
              value: "亳州市",
              label: "亳州市",
            },
            {
              prov: "安徽省",
              value: "池州市",
              label: "池州市",
            },
            {
              prov: "安徽省",
              value: "宣城市",
              label: "宣城市",
            },
          ],
        },
        {
          label: "福建省",
          value: "福建省",
          children: [
            {
              prov: "福建省",
              value: "福州市",
              label: "福州市",
            },
            {
              prov: "福建省",
              value: "厦门市",
              label: "厦门市",
            },
            {
              prov: "福建省",
              value: "衡水市",
              label: "莆田市",
            },
            {
              prov: "福建省",
              value: "三明市",
              label: "三明市",
            },
            {
              prov: "福建省",
              value: "泉州市",
              label: "泉州市",
            },
            {
              prov: "福建省",
              value: "漳州市",
              label: "漳州市",
            },
            {
              prov: "福建省",
              value: "南平市",
              label: "南平市",
            },
            {
              prov: "福建省",
              value: "龙岩市",
              label: "龙岩市",
            },
            {
              prov: "福建省",
              value: "宁德市",
              label: "宁德市",
            },
          ],
        },
        {
          label: "江西省",
          value: "江西省",
          children: [
            {
              prov: "江西省",
              value: "南昌市",
              label: "南昌市",
            },
            {
              prov: "江西省",
              value: "景德镇市",
              label: "景德镇市",
            },
            {
              prov: "江西省",
              value: "萍乡市",
              label: "萍乡市",
            },
            {
              prov: "江西省",
              value: "九江市",
              label: "九江市",
            },
            {
              prov: "江西省",
              value: "新余市",
              label: "新余市",
            },
            {
              prov: "江西省",
              value: "鹰潭市",
              label: "鹰潭市",
            },
            {
              prov: "江西省",
              value: "赣州市",
              label: "赣州市",
            },
            {
              prov: "江西省",
              value: "吉安市",
              label: "吉安市",
            },
            {
              prov: "江西省",
              value: "宜春市",
              label: "宜春市",
            },
            {
              prov: "江西省",
              value: "抚州市",
              label: "抚州市",
            },
            {
              prov: "江西省",
              value: "上饶市",
              label: "上饶市",
            },
          ],
        },
        {
          label: "山东省",
          value: "山东省",
          children: [
            {
              prov: "山东省",
              value: "济南市",
              label: "济南市",
            },
            {
              prov: "山东省",
              value: "青岛市",
              label: "青岛市",
            },
            {
              prov: "山东省",
              value: "淄博市",
              label: "淄博市",
            },
            {
              prov: "山东省",
              value: "枣庄市",
              label: "枣庄市",
            },
            {
              prov: "山东省",
              value: "东营市",
              label: "东营市",
            },
            {
              prov: "山东省",
              value: "烟台市",
              label: "烟台市",
            },
            {
              prov: "山东省",
              value: "潍坊市",
              label: "潍坊市",
            },
            {
              prov: "山东省",
              value: "济宁市",
              label: "济宁市",
            },
            {
              prov: "山东省",
              value: "泰安市",
              label: "泰安市",
            },
            {
              prov: "山东省",
              value: "威海市",
              label: "威海市",
            },
            {
              prov: "山东省",
              value: "日照市",
              label: "日照市",
            },
            {
              prov: "山东省",
              value: "莱芜市",
              label: "莱芜市",
            },
            {
              prov: "山东省",
              value: "临沂市",
              label: "临沂市",
            },
            {
              prov: "山东省",
              value: "德州市",
              label: "德州市",
            },
            {
              prov: "山东省",
              value: "聊城市",
              label: "聊城市",
            },
            {
              prov: "山东省",
              value: "滨州市",
              label: "滨州市",
            },
            {
              prov: "山东省",
              value: "菏泽市",
              label: "菏泽市",
            },
          ],
        },
        {
          label: "河南省",
          value: "河南省",
          children: [
            {
              prov: "河南省",
              value: "郑州市",
              label: "郑州市",
            },
            {
              prov: "河南省",
              value: "开封市",
              label: "开封市",
            },
            {
              prov: "河南省",
              value: "洛阳市",
              label: "洛阳市",
            },
            {
              prov: "河南省",
              value: "平顶山市",
              label: "平顶山市",
            },
            {
              prov: "河南省",
              value: "安阳市",
              label: "安阳市",
            },
            {
              prov: "河南省",
              value: "鹤壁市",
              label: "鹤壁市",
            },
            {
              prov: "河南省",
              value: "新乡市",
              label: "新乡市",
            },
            {
              prov: "河南省",
              value: "焦作市",
              label: "焦作市",
            },
            {
              prov: "河南省",
              value: "濮阳市",
              label: "濮阳市",
            },
            {
              prov: "河南省",
              value: "许昌市",
              label: "许昌市",
            },
            {
              prov: "河南省",
              value: "漯河市",
              label: "漯河市",
            },
            {
              prov: "河南省",
              value: "三门峡市",
              label: "三门峡市",
            },
            {
              prov: "河南省",
              value: "南阳市",
              label: "南阳市",
            },
            {
              prov: "河南省",
              value: "商丘市",
              label: "商丘市",
            },
            {
              prov: "河南省",
              value: "信阳市",
              label: "信阳市",
            },
            {
              prov: "河南省",
              value: "周口市",
              label: "周口市",
            },
            {
              prov: "河南省",
              value: "驻马店市",
              label: "驻马店市",
            },
            {
              prov: "河南省",
              value: "省直辖县级行政区划",
              label: "省直辖县级行政区划",
            },
          ],
        },
        {
          label: "湖北省",
          value: "湖北省",
          children: [
            {
              prov: "湖北省",
              value: "武汉市",
              label: "武汉市",
            },
            {
              prov: "湖北省",
              value: "黄石市",
              label: "黄石市",
            },
            {
              prov: "湖北省",
              value: "十堰市",
              label: "十堰市",
            },
            {
              prov: "湖北省",
              value: "宜昌市",
              label: "宜昌市",
            },
            {
              prov: "湖北省",
              value: "襄阳市",
              label: "襄阳市",
            },
            {
              prov: "湖北省",
              value: "鄂州市",
              label: "鄂州市",
            },
            {
              prov: "湖北省",
              value: "荆门市",
              label: "荆门市",
            },
            {
              prov: "湖北省",
              value: "孝感市",
              label: "孝感市",
            },
            {
              prov: "湖北省",
              value: "荆州市",
              label: "荆州市",
            },
            {
              prov: "湖北省",
              value: "黄冈市",
              label: "黄冈市",
            },
            {
              prov: "湖北省",
              value: "咸宁市",
              label: "咸宁市",
            },
            {
              prov: "湖北省",
              value: "随州市",
              label: "随州市",
            },
            {
              prov: "湖北省",
              value: "恩施土家族苗族自治州",
              label: "恩施土家族苗族自治州",
            },
            {
              prov: "湖北省",
              value: "省直辖县级行政区划",
              label: "省直辖县级行政区划",
            },
            {
              prov: "湖北省",
              value: "仙桃市",
              label: "仙桃市",
            },
            {
              prov: "湖北省",
              value: "潜江市",
              label: "潜江市",
            },
            {
              prov: "湖北省",
              value: "天门市",
              label: "天门市",
            },
            {
              prov: "湖北省",
              value: "神农架林区",
              label: "神农架林区",
            },
          ],
        },
        {
          label: "湖南省",
          value: "湖南省",
          children: [
            {
              prov: "湖南省",
              value: "长沙市",
              label: "长沙市",
            },
            {
              prov: "湖南省",
              value: "株洲市",
              label: "株洲市",
            },
            {
              prov: "湖南省",
              value: "湘潭市",
              label: "湘潭市",
            },
            {
              prov: "湖南省",
              value: "衡阳市",
              label: "衡阳市",
            },
            {
              prov: "湖南省",
              value: "邵阳市",
              label: "邵阳市",
            },
            {
              prov: "湖南省",
              value: "岳阳市",
              label: "岳阳市",
            },
            {
              prov: "湖南省",
              value: "常德市",
              label: "常德市",
            },
            {
              prov: "湖南省",
              value: "张家界市",
              label: "张家界市",
            },
            {
              prov: "湖南省",
              value: "益阳市",
              label: "益阳市",
            },
            {
              prov: "湖南省",
              value: "郴州市",
              label: "郴州市",
            },
            {
              prov: "湖南省",
              value: "永州市",
              label: "永州市",
            },
            {
              prov: "湖南省",
              value: "怀化市",
              label: "怀化市",
            },
            {
              prov: "湖南省",
              value: "娄底市",
              label: "娄底市",
            },
            {
              prov: "湖南省",
              value: "湘西土家族苗族自治州",
              label: "湘西土家族苗族自治州",
            },
          ],
        },
        {
          label: "广东省",
          value: "广东省",
          children: [
            {
              prov: "广东省",
              value: "广州市",
              label: "广州市",
            },
            {
              prov: "广东省",
              value: "韶关市",
              label: "韶关市",
            },
            {
              prov: "广东省",
              value: "深圳市",
              label: "深圳市",
            },
            {
              prov: "广东省",
              value: "珠海市",
              label: "珠海市",
            },
            {
              prov: "广东省",
              value: "汕头市",
              label: "汕头市",
            },
            {
              prov: "广东省",
              value: "佛山市",
              label: "佛山市",
            },
            {
              prov: "广东省",
              value: "江门市",
              label: "江门市",
            },
            {
              prov: "广东省",
              value: "湛江市",
              label: "湛江市",
            },
            {
              prov: "广东省",
              value: "茂名市",
              label: "茂名市",
            },
            {
              prov: "广东省",
              value: "肇庆市",
              label: "肇庆市",
            },
            {
              prov: "广东省",
              value: "惠州市",
              label: "惠州市",
            },
            {
              prov: "广东省",
              value: "梅州市",
              label: "梅州市",
            },
            {
              prov: "广东省",
              value: "汕尾市",
              label: "汕尾市",
            },
            {
              prov: "广东省",
              value: "河源市",
              label: "河源市",
            },
            {
              prov: "广东省",
              value: "阳江市",
              label: "阳江市",
            },
            {
              prov: "广东省",
              value: "清远市",
              label: "清远市",
            },
            {
              prov: "广东省",
              value: "东莞市",
              label: "东莞市",
            },
            {
              prov: "广东省",
              value: "中山市",
              label: "中山市",
            },
            {
              prov: "广东省",
              value: "潮州市",
              label: "潮州市",
            },
            {
              prov: "广东省",
              value: "揭阳市",
              label: "揭阳市",
            },
            {
              prov: "广东省",
              value: "云浮市",
              label: "云浮市",
            },
          ],
        },
        {
          label: "广西壮族自治区",
          value: "广西壮族自治区",
          children: [
            {
              prov: "广西壮族自治区",
              value: "南宁市",
              label: "南宁市",
            },
            {
              prov: "广西壮族自治区",
              value: "柳州市",
              label: "柳州市",
            },
            {
              prov: "广西壮族自治区",
              value: "桂林市",
              label: "桂林市",
            },
            {
              prov: "广西壮族自治区",
              value: "梧州市",
              label: "梧州市",
            },
            {
              prov: "广西壮族自治区",
              value: "北海市",
              label: "北海市",
            },
            {
              prov: "广西壮族自治区",
              value: "防城港市",
              label: "防城港市",
            },
            {
              prov: "广西壮族自治区",
              value: "钦州市",
              label: "钦州市",
            },
            {
              prov: "广西壮族自治区",
              value: "贵港市",
              label: "贵港市",
            },
            {
              prov: "广西壮族自治区",
              value: "玉林市",
              label: "玉林市",
            },
            {
              prov: "广西壮族自治区",
              value: "百色市",
              label: "百色市",
            },
            {
              prov: "广西壮族自治区",
              value: "贺州市",
              label: "贺州市",
            },
            {
              prov: "广西壮族自治区",
              value: "河池市",
              label: "河池市",
            },
            {
              prov: "广西壮族自治区",
              value: "来宾市",
              label: "来宾市",
            },
            {
              prov: "广西壮族自治区",
              value: "崇左市",
              label: "崇左市",
            },
          ],
        },
        {
          label: "海南省",
          value: "海南省",
          children: [
            {
              prov: "海南省",
              value: "海口市",
              label: "海口市",
            },
            {
              prov: "海南省",
              value: "三亚市",
              label: "三亚市",
            },
            {
              prov: "海南省",
              value: "三沙市",
              label: "三沙市",
            },
            {
              prov: "海南省",
              value: "省直辖县级行政区划",
              label: "省直辖县级行政区划",
            },
            {
              prov: "海南省",
              value: "五指山市",
              label: "五指山市",
            },
            {
              prov: "海南省",
              value: "琼海市",
              label: "琼海市",
            },
            {
              prov: "海南省",
              value: "儋州市",
              label: "儋州市",
            },
            {
              prov: "海南省",
              value: "文昌市",
              label: "文昌市",
            },
            {
              prov: "海南省",
              value: "万宁市",
              label: "万宁市",
            },
            {
              prov: "海南省",
              value: "东方市",
              label: "东方市",
            },
            {
              prov: "海南省",
              value: "定安县",
              label: "定安县",
            },
            {
              prov: "海南省",
              value: "屯昌县",
              label: "屯昌县",
            },
            {
              prov: "海南省",
              value: "澄迈县",
              label: "澄迈县",
            },
            {
              prov: "海南省",
              value: "临高县",
              label: "临高县",
            },
            {
              prov: "海南省",
              value: "白沙黎族自治县",
              label: "白沙黎族自治县",
            },
            {
              prov: "海南省",
              value: "昌江黎族自治县",
              label: "昌江黎族自治县",
            },
            {
              prov: "海南省",
              value: "乐东黎族自治县",
              label: "乐东黎族自治县",
            },
            {
              prov: "海南省",
              value: "陵水黎族自治县",
              label: "陵水黎族自治县",
            },
            {
              prov: "海南省",
              value: "保亭黎族苗族自治县",
              label: "保亭黎族苗族自治县",
            },
            {
              prov: "海南省",
              value: "琼中黎族苗族自治县",
              label: "琼中黎族苗族自治县",
            },
          ],
        },
        {
          label: "重庆市",
          value: "重庆市",
        },
        {
          label: "四川省",
          value: "四川省",
          children: [
            {
              prov: "四川省",
              value: "成都市",
              label: "成都市",
            },
            {
              prov: "四川省",
              value: "自贡市",
              label: "自贡市",
            },
            {
              prov: "四川省",
              value: "攀枝花市",
              label: "攀枝花市",
            },
            {
              prov: "四川省",
              value: "泸州市",
              label: "泸州市",
            },
            {
              prov: "四川省",
              value: "德阳市",
              label: "德阳市",
            },
            {
              prov: "四川省",
              value: "绵阳市",
              label: "绵阳市",
            },
            {
              prov: "四川省",
              value: "广元市",
              label: "广元市",
            },
            {
              prov: "四川省",
              value: "遂宁市",
              label: "遂宁市",
            },
            {
              prov: "四川省",
              value: "内江市",
              label: "内江市",
            },
            {
              prov: "四川省",
              value: "乐山市",
              label: "乐山市",
            },
            {
              prov: "四川省",
              value: "南充市",
              label: "南充市",
            },
            {
              prov: "四川省",
              value: "眉山市",
              label: "眉山市",
            },
            {
              prov: "四川省",
              value: "宜宾市",
              label: "宜宾市",
            },
            {
              prov: "四川省",
              value: "广安市",
              label: "广安市",
            },
            {
              prov: "四川省",
              value: "达州市",
              label: "达州市",
            },
            {
              prov: "四川省",
              value: "雅安市",
              label: "雅安市",
            },
            {
              prov: "四川省",
              value: "巴中市",
              label: "巴中市",
            },
            {
              prov: "四川省",
              value: "资阳市",
              label: "资阳市",
            },
            {
              prov: "四川省",
              value: "阿坝藏族羌族自治州",
              label: "阿坝藏族羌族自治州",
            },
            {
              prov: "四川省",
              value: "甘孜藏族自治州",
              label: "甘孜藏族自治州",
            },
            {
              prov: "四川省",
              value: "凉山彝族自治州",
              label: "凉山彝族自治州",
            },
          ],
        },
        {
          label: "贵州省",
          value: "贵州省",
          children: [
            {
              prov: "贵州省",
              value: "贵阳市",
              label: "贵阳市",
            },
            {
              prov: "贵州省",
              value: "六盘水市",
              label: "六盘水市",
            },
            {
              prov: "贵州省",
              value: "遵义市",
              label: "遵义市",
            },
            {
              prov: "贵州省",
              value: "安顺市",
              label: "安顺市",
            },
            {
              prov: "贵州省",
              value: "毕节市",
              label: "毕节市",
            },
            {
              prov: "贵州省",
              value: "铜仁市",
              label: "铜仁市",
            },
            {
              prov: "贵州省",
              value: "黔西南布依族苗族自治州",
              label: "黔西南布依族苗族自治州",
            },
            {
              prov: "贵州省",
              value: "黔东南苗族侗族自治州",
              label: "黔东南苗族侗族自治州",
            },
            {
              prov: "贵州省",
              value: "黔南布依族苗族自治州",
              label: "黔南布依族苗族自治州",
            },
          ],
        },
        {
          label: "云南省",
          value: "云南省",
          children: [
            {
              prov: "云南省",
              value: "昆明市",
              label: "昆明市",
            },
            {
              prov: "云南省",
              value: "曲靖市",
              label: "曲靖市",
            },
            {
              prov: "云南省",
              value: "玉溪市",
              label: "玉溪市",
            },
            {
              prov: "云南省",
              value: "保山市",
              label: "保山市",
            },
            {
              prov: "云南省",
              value: "昭通市",
              label: "昭通市",
            },
            {
              prov: "云南省",
              value: "丽江市",
              label: "丽江市",
            },
            {
              prov: "云南省",
              value: "普洱市",
              label: "普洱市",
            },
            {
              prov: "云南省",
              value: "临沧市",
              label: "临沧市",
            },
            {
              prov: "云南省",
              value: "楚雄彝族自治州",
              label: "楚雄彝族自治州",
            },
            {
              prov: "云南省",
              value: "红河哈尼族彝族自治州",
              label: "红河哈尼族彝族自治州",
            },
            {
              prov: "云南省",
              value: "文山壮族苗族自治州",
              label: "文山壮族苗族自治州",
            },
            {
              prov: "云南省",
              value: "西双版纳傣族自治州",
              label: "西双版纳傣族自治州",
            },
            {
              prov: "云南省",
              value: "大理白族自治州",
              label: "大理白族自治州",
            },
            {
              prov: "云南省",
              value: "德宏傣族景颇族自治州",
              label: "德宏傣族景颇族自治州",
            },
            {
              prov: "云南省",
              value: "怒江傈僳族自治州",
              label: "怒江傈僳族自治州",
            },
            {
              prov: "云南省",
              value: "迪庆藏族自治州",
              label: "迪庆藏族自治州",
            },
          ],
        },
        {
          label: "西藏自治区",
          value: "西藏治区",
          children: [
            {
              prov: "西藏自治区",
              value: "拉萨市",
              label: "拉萨市",
            },
            {
              prov: "西藏自治区",
              value: "昌都地区",
              label: "昌都地区",
            },
            {
              prov: "西藏自治区",
              value: "山南地区",
              label: "山南地区",
            },
            {
              prov: "西藏自治区",
              value: "日喀则地区",
              label: "日喀则地区",
            },
            {
              prov: "西藏自治区",
              value: "那曲地区",
              label: "那曲地区",
            },
            {
              prov: "西藏自治区",
              value: "阿里地区",
              label: "阿里地区",
            },
            {
              prov: "西藏自治区",
              value: "林芝地区",
              label: "林芝地区",
            },
          ],
        },
        {
          label: "陕西省",
          value: "陕西省",
          children: [
            {
              prov: "陕西省",
              value: "西安市",
              label: "西安市",
            },
            {
              prov: "陕西省",
              value: "铜川市",
              label: "铜川市",
            },
            {
              prov: "陕西省",
              value: "宝鸡市",
              label: "宝鸡市",
            },
            {
              prov: "陕西省",
              value: "咸阳市",
              label: "咸阳市",
            },
            {
              prov: "陕西省",
              value: "渭南市",
              label: "渭南市",
            },
            {
              prov: "陕西省",
              value: "延安市",
              label: "延安市",
            },
            {
              prov: "陕西省",
              value: "汉中市",
              label: "汉中市",
            },
            {
              prov: "陕西省",
              value: "榆林市",
              label: "榆林市",
            },
            {
              prov: "陕西省",
              value: "安康市",
              label: "安康市",
            },
            {
              prov: "陕西省",
              value: "商洛市",
              label: "商洛市",
            },
          ],
        },
        {
          label: "甘肃省",
          value: "甘肃省",
          children: [
            {
              prov: "甘肃省",
              value: "兰州市",
              label: "兰州市",
            },
            {
              prov: "甘肃省",
              value: "嘉峪关市",
              label: "嘉峪关市",
            },
            {
              prov: "甘肃省",
              value: "金昌市",
              label: "金昌市",
            },
            {
              prov: "甘肃省",
              value: "白银市",
              label: "白银市",
            },
            {
              prov: "甘肃省",
              value: "天水市",
              label: "天水市",
            },
            {
              prov: "甘肃省",
              value: "武威市",
              label: "武威市",
            },
            {
              prov: "甘肃省",
              value: "张掖市",
              label: "张掖市",
            },
            {
              prov: "甘肃省",
              value: "平凉市",
              label: "平凉市",
            },
            {
              prov: "甘肃省",
              value: "酒泉市",
              label: "酒泉市",
            },
            {
              prov: "甘肃省",
              value: "庆阳市",
              label: "庆阳市",
            },
            {
              prov: "甘肃省",
              value: "定西市",
              label: "定西市",
            },
            {
              prov: "甘肃省",
              value: "陇南市",
              label: "陇南市",
            },
            {
              prov: "甘肃省",
              value: "临夏回族自治州",
              label: "临夏回族自治州",
            },
            {
              prov: "甘肃省",
              value: "甘南藏族自治州",
              label: "甘南藏族自治州",
            },
          ],
        },
        {
          label: "青海省",
          value: "青海省",
          children: [
            {
              prov: "青海省",
              value: "西宁市",
              label: "西宁市",
            },
            {
              prov: "青海省",
              value: "海东市",
              label: "海东市",
            },
            {
              prov: "青海省",
              value: "海北藏族自治州",
              label: "海北藏族自治州",
            },
            {
              prov: "青海省",
              value: "黄南藏族自治州",
              label: "黄南藏族自治州",
            },
            {
              prov: "青海省",
              value: "海南藏族自治州",
              label: "海南藏族自治州",
            },
            {
              prov: "青海省",
              value: "果洛藏族自治州",
              label: "果洛藏族自治州",
            },
            {
              prov: "青海省",
              value: "玉树藏族自治州",
              label: "玉树藏族自治州",
            },
            {
              prov: "青海省",
              value: "海西蒙古族藏族自治州",
              label: "海西蒙古族藏族自治州",
            },
          ],
        },
        {
          label: "宁夏回族自治区",
          value: "宁夏回族自治区",
          children: [
            {
              prov: "宁夏回族自治区",
              value: "银川市",
              label: "银川市",
            },
            {
              prov: "宁夏回族自治区",
              value: "石嘴山市",
              label: "石嘴山市",
            },
            {
              prov: "宁夏回族自治区",
              value: "吴忠市",
              label: "吴忠市",
            },
            {
              prov: "宁夏回族自治区",
              value: "固原市",
              label: "固原市",
            },
            {
              prov: "宁夏回族自治区",
              value: "中卫市",
              label: "中卫市",
            },
          ],
        },
        {
          label: "新疆维吾尔自治区",
          value: "新疆维吾尔自治区",
          children: [
            {
              prov: "新疆维吾尔自治区",
              value: "乌鲁木齐市",
              label: "乌鲁木齐市",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "克拉玛依市",
              label: "克拉玛依市",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "吐鲁番地区",
              label: "吐鲁番地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "哈密地区",
              label: "哈密地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "昌吉回族自治州",
              label: "昌吉回族自治州",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "博尔塔拉蒙古自治州",
              label: "博尔塔拉蒙古自治州",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "巴音郭楞蒙古自治州",
              label: "巴音郭楞蒙古自治州",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "阿克苏地区",
              label: "阿克苏地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "克孜勒苏柯尔克孜自治州",
              label: "克孜勒苏柯尔克孜自治州",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "喀什地区",
              label: "喀什地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "和田地区",
              label: "和田地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "伊犁哈萨克自治州",
              label: "伊犁哈萨克自治州",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "塔城地区",
              label: "塔城地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "阿勒泰地区",
              label: "阿勒泰地区",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "自治区直辖县级行政区划",
              label: "自治区直辖县级行政区划",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "石河子市",
              label: "石河子市",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "阿拉尔市",
              label: "阿拉尔市",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "图木舒克市",
              label: "图木舒克市",
            },
            {
              prov: "新疆维吾尔自治区",
              value: "五家渠市",
              label: "五家渠市",
            },
          ],
        },
        {
          label: "台湾省",
          value: "台湾省",
          children: [
            {
              prov: "台湾省",
              value: "台北市",
              label: "台北市",
            },
            {
              prov: "台湾省",
              value: "高雄市",
              label: "高雄市",
            },
            {
              prov: "台湾省",
              value: "基隆市",
              label: "基隆市",
            },
            {
              prov: "台湾省",
              value: "台中市",
              label: "台中市",
            },
            {
              prov: "台湾省",
              value: "台南市",
              label: "台南市",
            },
            {
              prov: "台湾省",
              value: "新竹市",
              label: "新竹市",
            },
            {
              prov: "台湾省",
              value: "嘉义市",
              label: "嘉义市",
            },
            {
              prov: "台湾省",
              value: "省直辖",
              label: "省直辖",
            },
          ],
        },
        {
          label: "香港特别行政区",
          value: "香港特别行政区",
          children: [
            {
              prov: "香港特别行政区",
              value: "香港岛",
              label: "香港岛",
            },
            {
              prov: "香港特别行政区",
              value: "九龙",
              label: "九龙",
            },
            {
              prov: "香港特别行政区",
              value: "新界",
              label: "新界",
            },
          ],
        },
        {
          label: "澳门特别行政区",
          value: "澳门特别行政区",
          children: [
            {
              prov: "澳门特别行政区",
              value: "澳门半岛",
              label: "澳门半岛",
            },
            {
              prov: "澳门特别行政区",
              value: "澳门离岛",
              label: "澳门离岛",
            },
            {
              prov: "澳门特别行政区",
              value: "无堂区划分区域",
              label: "无堂区划分区域",
            },
          ],
        },
      ],
      positionList: [
                {
                    value: "住院医师",
                    label: "住院医师"
                },
                {
                    value: "主治医师",
                    label: "主治医师"
                },
                {
                    value: '副主任医师',
                    label: "副主任医师"
                },
                {
                    value: '主任医师',
                    label: "主任医师"
                }
            ],//职称列表
      roleList:[
        {
                    value: "中心管理员",
                    label: "中心管理员"
                },
                {
                    value: "医生",
                    label: "医生"
                },
      ],//角色列表
      userInfo: {
        avatar: "",
      },

      formItem: {
        name: "",
        gender: "male",
        age: "",
        position: "",
        province: "",
        city: "",
        street: "",
        hospital: "",
        department: "",
        synopsis: "", //介绍
        adept: "", //擅长
        phone: "", //手机号
        code: "", //验证码
        password: "",
        repassword: "",
        physicians: "", //医师资格证编码
        physiciansurl: "", //医师资格证图片url
        professional: "", //职业资格证编码
        professionalurl: "", //职业资格证图片url
        healthOrgId: "", //医院ID
        deptID: "", //注册Anymed必须的额外参数(在请求科室的接口返回中)
        roleID: "", //权限ID
        role: "", //权限名称
        ID: "", //医生表ID  新建空值或不填，修改具体值
        type: "", //医生类型（中心、基层）
      },

      isagreen:false,//是否勾选知情同意书
    };
  },
  created() {
    // window.localStorage.setItem("Role","")
    // window.localStorage.setItem("Role1","")

    console.log(window.localStorage.getItem("Role1")=="","111")
    if (window.localStorage.getItem("Role")=="") {
      console.log(1);
      this.getStorage();
      // this.getDocDatas(window.localStorage.getItem("UserJid"));
    } else if (window.localStorage.getItem("Role")!="") {
      this.sUserJID = JSON.parse(window.localStorage.getItem("Role"))?JSON.parse(window.localStorage.getItem("Role")).UserJid:"";
      this.getStorage();
      console.log(2);
    }
    // console.log(window.localStorage.getItem("UserJid"));
  },
  mounted() {
    this.physiciansList = this.$refs.upload1.fileList;
    this.professionalList = this.$refs.upload2.fileList;
    // console.log(window.localStorage.getItem("username"));
    this.getTeamList();
    this.change();
  },
  methods: {
    okbook(which){
      if(which == 'y'){
        this.fullmodal = false
        this.isagreen = true
      }else if(which == 'n'){
        this.fullmodal = false
        this.isagreen = true
      }
    },
    /* 知情同意书 */
    disclaimer(value){
      // console.log(value)
      this.isagreen = value
    },
    /* ================================================接口================================================================================== */
    //发送验证码
    messageCode() {
      Request.postRequest(config.SXG_baseUrl + "/api/login/SMSMessage", {
        sPhoneNUM: this.formItem.phone,
        authCode: "",
      }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          console.log(1)
        }
      });
    },
    //验证验证码
    ismessageCode() {
      
      if (this.formItem.code == "") {
        this.$Message.info("请输入验证码！");
      } else {
        console.log(1)
        if(this.departmentList.length>0){
        this.departmentList.map((item) => {
        if (item.DepartmentName == this.formItem.department) {
          console.log(this.formItem.department)
          this.formItem.deptID = item.ID;
        }
      });
      }
        Request.postRequest(config.SXG_baseUrl + "/api/login/SMSMessage", {
          sPhoneNUM: this.formItem.phone,
          authCode: this.formItem.code,
        }).then((res) => {
          // console.log(res);
          if (res.code == 200) {
            Request.postRequest(
              config.SXG_baseUrl + "/api/docmanager/RegistMedcareUser",
              {
                DocName: this.formItem.name,
                Age: this.formItem.age,
                Sex: this.formItem.gender == "male" ? "男" : "女",
                Cellphone: this.formItem.phone,
                UserPws: this.formItem.password,
                ImgUrl: this.uploadList.url,
                Introduce: this.formItem.synopsis,
                Skill: this.formItem.adept,
                DocPosition: this.formItem.position,
                Province: this.formItem.province,
                City: this.formItem.city,
                Address: this.formItem.street,
                VocQFCode: this.formItem.professional?this.formItem.professional:"",
                VocQFCodeUrl: JSON.stringify(this.imgList2),
                DocQFCode: this.formItem.physicians?this.formItem.physicians:"",
                DocQFUrl: JSON.stringify(this.imgList1),
                DocType: "基层",
                Status: "1",
                Role:"医生",
                RoleID:"1",
                HealthOrgID: this.hospitalList[0]?this.hospitalList[0].ID:"",
                DeptID: this.formItem.deptID,
                HospitalName: this.formItem.hospital,
                ID: this.formItem.ID,
                // CenterID: this.centerID,
                // CenterName: this.centerTeam,
                DepartmentName:this.formItem.department,
                DepartmentID:this.formItem.deptID,
              }
            ).then((res) => {
              if (res.code == 200) {
                Request.addLog('注册','注册系统')
                // console.log(res);
                /* ---------------------------------------------调用更换头像的接口------------------------------------------------------------------ */
                Request.postRequest(config.SXG_baseUrl +"/api/docmanager/UploadUserHeadImageBybase64",{
                  sUserJID:res.data.UserJid,
                  sHeadPhoto:this.picture.substring(22)
                }).then((res)=>{
                  // console.log(res)
                })
                content.scrollIntoView();
                this.$Message.success("成功！");
                window.localStorage.setItem("UserJid", res.data.UserJid);
                this.sUserJID = res.data.UserJid;
               this.getDocDatas(res.data.UserJid);
                
              } else if (res.code == 300) {
                Request.addLog('注册','注册系统',"F",res.message)
                if (res.message) {
                  this.$Message.info(res.message);
                } else {
                  this.$Message.info("请正确填写每一项！");
                }
              }
            });
          } else {
            Request.addLog('注册','注册系统',"F",res.message)
            this.$Message.info(res.message);
          }
        });
      }
    },
    //提交成功后根据医生ID或者UserJid获取医生详细信息(sxg)
    getDocDatas(userJid) {
      Request.getRequest(
        config.SXG_baseUrl + "/api/docmanager/GetDocDetailByJID",
        {
          UserJid: userJid,
        }
      ).then((res) => {
        // console.log(res.data[0].Status);
        window.localStorage.setItem("Role1", JSON.stringify(res.data));
        // this.$router.push("/HomePage/PersonalInformation");
        if ( this.cache.Status == 3) {
            this.isshow = false;
            this.disabled = false;
            // this.$router.push("/HomePage/PersonalInformation");
          } else if ( this.cache.Status == 1) {
            this.disabled = true;
            this.isshow = true;
            this.status = "已提交，待审核";
          } else if ( this.cache.Status == 2) {
            this.disabled = true;
            this.isshow = true;
            this.status = "未通过";
          } else if ( this.cache.Status == 0) {
            this.disabled = false;
            this.isshow = false;
          }
        this.formItem = {
          name: res.data.DocName,
          gender: res.data.Sex == "男" ? "male" : "female",
          position: res.data.DocPosition,
          age: res.data.Age,
          province: res.data.Province,
          city: res.data.City,
          street: res.data.Address,
          hospital: res.data.HospitalName,
          department: res.data.DepartmentName,
          synopsis: res.data.Introduce,
          adept: res.data.Skill,
          phone: res.data.Cellphone,
          password: res.data.UserPws,
          repassword: res.data.UserPws,
          physicians: res.data.DocQFCode,
          // physiciansurl: res.data.DocQFUrl,
          professional: res.data.VocQFCode,
          // professionalurl: res.data.VocQFCodeUrl,
          healthOrgId: res.data.HealthOrgID,
          deptID: res.data.DepartmentID,
          role: res.data.Role,
          roleID: res.data.RoleID,
          ID: res.data.ID,
          type: res.data.DocType,
        };
        this.centerTeam = res.data.CenterName; //中心团队的名称---------------26
        this.centerID = res.data.CenterID; //中心团队ID---------------27
        this.uploadList.url = res.data.ImgUrl;
          let arr1 = []
          let arr2 = []
          if(JSON.parse(res.data.DocQFUrl)[0]==""){
            arr1 = []
          }else if(JSON.parse(res.data.DocQFUrl)[0]!=""){
            if(JSON.parse(res.data.DocQFUrl)[1]==""){
              arr1 = [{url:JSON.parse(res.data.DocQFUrl)[0]}]
            }
            else{
            arr1 = [{url:JSON.parse(res.data.DocQFUrl)[0]},{url:JSON.parse(res.data.DocQFUrl)[1]}]
            }
          }



          if(JSON.parse(res.data.VocQFCodeUrl)[0]==""){
            arr2 = []
          }else if(JSON.parse(res.data.VocQFCodeUrl)[0]!=""){
            if(JSON.parse(res.data.VocQFCodeUrl)[1]==""){
              arr2 = [{url:JSON.parse(res.data.VocQFCodeUrl)[0]}]
            }else{
              arr2 = [{url:JSON.parse(res.data.VocQFCodeUrl)[0]},{url:JSON.parse(res.data.VocQFCodeUrl)[1]}]
            }
          }
          this.physiciansList =arr1
          this.professionalList =arr2
        // this.physiciansList.push({
        //   url: this.formItem.physiciansurl,
        //   name: this.formItem.physiciansurl,
        // });
        // // console.log(this.physiciansList);
        // this.professionalList.push({
        //   url: this.formItem.professionalurl,
        //   name: this.formItem.professionalurl,
        // });
        
          this.change()
      });
    },
    //获取医院列表
    getHospitalDatas(val) {
      this.isHosLoading = true;
      Request.postRequest(
        config.SXG_baseUrl + "/api/docmanager/GetAllHospitalsByFilter",
        { sFilter: val }
      ).then((res) => {
        if (res.code == 200) {
          this.isHosLoading = false;
          // console.log(res);
          if (res.data.length > 0) {
            this.hospitalList = res.data;
            this.getDepartmentDatas(res.data[0].OrgName);
            // this.hospitalList = res.data.map((item) => {
            //   return {
            //     value: item.OrgName,
            //     label: item.HealthOrgID,
            //   };
            // });
          }
        }
      });
    },
    //获取科室列表
    getDepartmentDatas(hos) {
      // console.log(this.hospitalList);
      if (hos) {
        let HealthOrgID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == hos) {
            HealthOrgID = item.ID;
          }
        });
        Request.postRequest(
          config.SXG_baseUrl + "/api/docmanager/GetDepartmentsByFilter",
          { sFilter: HealthOrgID }
        ).then((res) => {
          if (res.code == 200) {
            this.isDepLoading = false;
            // console.log(res, "---");
            // this.formItem.department = "";
            this.departmentList = res.data;
          }
        });
      }
    },
    //获取团队列表
    getTeamList() {
      Request.getRequest(config.SXG_baseUrl + "/api/currency/GetRecordDetail", {
        tablename: "CenterHospital",
        fields: "ID,Team",
      }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.centerTeamList = res.data;
        }
      });
    },
    /* =============================================省改变后的================================================================================= */
    change() {
      this.cityList = [];
      this.provinceList.map((item) => {
        if (item.children) {
          if (item.value == this.formItem.province) {
            this.cityList = item.children;
          }
        } else {
          if (item.value == this.formItem.province) {
            this.cityList[0] = item;
          }
        }
      });
    },
    //================================================================================================================
    //头像上传
    /* 获取base64的 */
     getBase64(file) {
       return new Promise(function(resolve, reject) {
         let reader = new FileReader();
         let imgResult = "";
         reader.readAsDataURL(file);
         reader.onload = function() {
           imgResult = reader.result;
         };
         reader.onerror = function(error) {
           reject(error);
         };
         reader.onloadend = function() {
           resolve(imgResult);
         };
       });
     },
    //头像上传之前
    beforeUpload(pic){
      this.getBase64(pic).then(res=>{
      this.picture = res
        // console.log(res)
      })
        // console.log(this.picture,'picture')
    },
    //上传头像成功后
    handleSuccess(res, file) {
      // console.log(file,"success")
      // console.log(res);
      this.uploadList.url = res.data[0];
        this.img = res.data[0];
      return 
      let _res = res;
      
      if (res.code == 200) {
        this.getDocDatas(
          JSON.parse(window.localStorage.getItem("Role")).UserJid
        );
        this.$Message.success(_res.data);
      }
    },
    changehead() {
      // console.log(this.sUserJID);
    },
    //上传的文件格式不对或大小太大时，三个上传公用以下两个方法
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确!",
        desc: file.name + "的文件格式不正确，请选择jpg或png",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超过文件大小限制！",
        desc: file.name + "文件太大，不超过2M。",
      });
    },
    //选择性别时候的默认头像（未上传头像时）
    gender(a) {
        // console.log(a);
      if (this.isupload === false) {
        console.log(1)
        if (a == "male") {
          this.uploadList.url =
            "https://www.sino-med.net:444/Applications/bcc183de-8a7f-4eda-b46f-419d008795e1/AppFiles/SurgeryPlatform/2021/06/04/16227850609613756.png";
        } else {
          this.uploadList.url =
            "https://www.sino-med.net:444/Applications/bcc183de-8a7f-4eda-b46f-419d008795e1/AppFiles/SurgeryPlatform/2021/06/04/16227850825543045.png";
        }
      }
    },
    //================================================================================================================
    //医师资格证上传
    handleSuccess1(res, file) {
      // console.log(file);
      // console.log(res);
      // console.log(this.defaultList2);
      file.url = res.data[0];
      file.name = res.data[0];
      this.formItem.physiciansurl = res.data[0];
      // console.log(this.formItem.physiciansurl);
    },
    handleBeforeUpload1() {
      const check = this.physiciansList.length < 2;
      if (!check) {
        this.$Notice.warning({
          title: "最多可以上传两张图片！",
        });
      }
      return check;
    },
    //查看图片--医师资格证
    showphysicianspicture() {
      this.imgName = this.physicianspicture;
      this.visible = true;
    },
    showphysicians(item) {
      // this.$Message.info("啊哈");
      this.imgName = item.url;
      this.visible = true;
    },
    handleRemove1(file) {
      const fileList1 = this.$refs.upload1.fileList;
      this.$refs.upload1.fileList.splice(fileList1.indexOf(file), 1);
    },
    ok1(file) {
      this.handleRemove1(file);
      this.$Message.info("已删除！");
    },
    cancel1() {
      this.$Message.info("点击了取消！");
    },
    //================================================================================================================
    //职业资格证上传
    handleSuccess2(res, file) {
      console.log(res);
      // console.log(file);
      // console.log(this.professionalList);
      file.url = res.data[0];
      file.name = res.data[0];
      this.formItem.professionalurl = res.data[0];
    },
    handleBeforeUpload2() {
      const check = this.professionalList.length < 2;
      if (!check) {
        this.$Notice.warning({
          title: "最多可以上传两张图片！",
        });
      }
      return check;
    },
    //查看图片--职业资格证
    showprofessionalpicture() {
      this.imgName = this.professionalpicture;
      this.visible = true;
    },
    showprofessional(item) {
      // this.$Message.info("啊哈");
      this.imgName = item.url;
      this.visible = true;
    },
    handleRemove2(file) {
      const fileList2 = this.$refs.upload2.fileList;
      this.$refs.upload2.fileList.splice(fileList2.indexOf(file), 1);
    },
    ok2(file) {
      this.handleRemove2(file);
      this.$Message.info("已删除！");
    },
    cancel2() {
      this.$Message.info("点击了取消！");
    },
    //================================================================================================================
    //发送验证码
    sendCode() {
      // console.log(this.formItem.phone)
      if (tools.checkPhone(this.formItem.phone)) {
        this.messageCode();
        this.$Message.info("验证码已发送！");
        this.ifsendcode = false;
        this.time = 60;
        let _this = this;
        this.loading = true;
        var timer = setInterval(function () {
          _this.time--;
          if (_this.time == 0) {
            _this.ifsendcode = true;
            _this.time = "";
            clearInterval(timer);
            _this.loading = false;
          }
        }, 1000);
      } else {
        this.$Message.info("请输入正确的手机号！");
      }
    },
    /* ==========================================取缓存设置回填==================================================================== */
    getStorage() {
      //此页面只有注册后刷新使用了Role1,其他情况都使用Role
      if(window.localStorage.getItem("Role1")!="" && window.localStorage.getItem("Role")==""){
        //注册后在注册页刷新
        this.cache = window.localStorage.getItem("Role1")==""?"":JSON.parse(window.localStorage.getItem("Role1"));
        console.log("Role1")
      }else{
        console.log("Role")
        this.cache = window.localStorage.getItem("Role")==""?"":JSON.parse(window.localStorage.getItem("Role"));
        // this.cache = ""
      }
      if(window.localStorage.getItem("Role1")==null){
        this.cache = ""
      }
      // console.log(this.cache)
      if(this.cache != "" || this.cache != null){
        if ( this.cache.Status == 3) {
         console.log(3)
            this.isshow = false;
            this.disabled = false;
            // this.$router.push("/HomePage/PersonalInformation");
          } else if ( this.cache.Status == 1) {
         console.log(1)
            this.disabled = true;
            this.isshow = true;
            this.status = "已提交，待审核";
          } else if ( this.cache.Status == 2) {
         console.log(this.cache.Status,2)
            this.disabled = true;
            this.isshow = true;
            this.status = "未通过";
          } else if ( this.cache.Status == 0) {
         console.log(0)
            this.disabled = true;
            this.isshow = true;
            this.status = "已提交，待审核";
          }else {
         console.log("其他")
            this.disabled = false;
            this.isshow = false;
            this.status = "";
          }
      }
       
      // console.log(this.cache.ID);
      if(this.cache!=null){
        this.formItem.name = this.cache.DocName; //姓名---------------1
      if (this.cache.Sex == "男") {
        //性别---------------2
        this.formItem.gender = "male";
      } else {
        this.formItem.gender = "female";
      }
      if (this.cache.ImgUrl) {
        //头像---------------3
        this.uploadList.url = this.cache.ImgUrl;
        this.isupload = true;
      }
      this.formItem.position = this.cache.DocPosition; //职称---------------4
      this.formItem.age = this.cache.Age; //年龄---------------5
      this.formItem.province = this.cache.Province; //省---------------6
      this.formItem.city = this.cache.City; //市---------------7
      this.formItem.street = this.cache.Address; //街道---------------8
      this.formItem.hospital = this.cache.HospitalName; //医院---------------9
      this.formItem.department = this.cache.DepartmentName;
      this.formItem.synopsis = this.cache.Introduce; //简介---------------10
      this.formItem.adept = this.cache.Skill; //擅长---------------11
      this.formItem.phone = this.cache.Cellphone; //手机号---------------12
      this.formItem.password = this.cache.UserPws; //密码---------------13
      this.formItem.physicians = this.cache.DocQFCode; //医师资格证编码---------------14
      this.formItem.physiciansurl = this.cache.DocQFUrl; //医师资格证图片url---------------15
      this.physiciansList[0] = {
        url: this.formItem.physiciansurl,
        name: this.formItem.physiciansurl,
      };
      // console.log(this.physiciansList);
      this.formItem.professional = this.cache.VocQFCode; //职业资格证编码---------------16
      this.formItem.professionalurl = this.cache.VocQFCodeUrl; //职业资格证图片url---------------17
      this.professionalList.url = this.formItem.professionalurl;
      this.professionalList[0] = {
        url: this.formItem.professionalurl,
        name: this.formItem.professionalurl,
      };
      this.formItem.province = this.cache.Province; //省名---------------18
      this.formItem.city = this.cache.City; //市名---------------19
      this.formItem.healthOrgId = this.cache.HealthOrgID; //医院ID---------------20
      this.formItem.deptID = this.cache.HealthOrgID; //注册Anymed必须的额外参数---------------21
      this.formItem.role = this.cache.Role; //权限名称---------------22
      this.formItem.roleID = this.cache.RoleID; //权限ID---------------23
      this.formItem.ID = this.cache.ID; //权限ID---------------24
      this.formItem.type = this.cache.DocType; //医生类型（中心、基层）---------------25
      this.centerTeam = this.cache.CenterName; //中心团队的名称---------------26
      this.centerID = this.cache.CenterID; //中心团队ID---------------27
      }
      
    },
    //===========================================提交表单=====================================================================
    submit() {
      if (this.physiciansList.length == 1) {
        this.imgList1[0] = this.physiciansList[0].url
          ? this.physiciansList[0].url
          : "";
      }
      if (this.physiciansList.length>1) {
        this.imgList1[0] = this.physiciansList[0].url
          ? this.physiciansList[0].url
          : "";
        this.imgList1[1] = this.physiciansList[1].url
          ? this.physiciansList[1].url
          : "";
      }else{
        this.imgList1[1] = ""
      }

      if (this.professionalList.length ==1) {
        this.imgList2[0] = this.professionalList[0].url
          ? this.professionalList[0].url
          : "";
      }
      if (this.professionalList.length>1) {
        this.imgList2[0] = this.professionalList[0].url
          ? this.professionalList[0].url
          : "";
        this.imgList2[1] = this.professionalList[1].url
          ? this.professionalList[1].url
          : "";
      }else{
        this.imgList2[1] = ""
      }
      for(let i = 0;i<this.imgList1.length;i++){
        if(this.imgList1[i] == null){
          this.imgList1[i] = ""
        }
      }
      for(let i = 0;i<this.imgList2.length;i++){
        if(this.imgList2[i] == null){
          this.imgList2[i] = ""
        }
      }
      for(let i = 0;i<this.imgList1.length;i++){
        if(this.imgList1[i] == null){
          this.imgList1[i] = ""
        }
      }
      for(let i = 0;i<this.imgList2.length;i++){
        if(this.imgList2[i] == null){
          this.imgList2[i] = ""
        }
      }
      // this.disabled = false;
      // console.log(this.formItem.professionalurl);
      // console.log(this.professionalList);
      // this.modal1 = true;
      this.ismessageCode();
      // console.log(this.formItem);
      // console.log(this.centerTeam);
      // console.log(this.centerID);
    },
    teamChange(i) {
      
      // console.log(this.centerTeam);
      this.centerTeamList.map((item) => {
        if (item.Team == i) {
          this.centerID = item.ID;
        }
      });
      // console.log(this.centerID);
    },
    okTeam() {
      
      // console.log(this.formItem.healthOrgId)

      // console.log(this.hospitalList)
              // console.log(this.picture)
      //   if(this.departmentList.length>0){
      //   this.departmentList.map((item) => {
      //   if (item.DepartmentName == this.formItem.department) {
      //     console.log(this.formItem.department)
      //     this.formItem.deptID = item.ID;
      //   }
      // });
      // Request.postRequest(
      //         config.SXG_baseUrl + "/api/docmanager/RegistMedcareUser",
      //         {
      //           DocName: this.formItem.name,
      //           Age: this.formItem.age,
      //           Sex: this.formItem.gender == "male" ? "男" : "女",
      //           Cellphone: this.formItem.phone,
      //           UserPws: this.formItem.password,
      //           ImgUrl: this.uploadList.url,
      //           Introduce: this.formItem.synopsis,
      //           Skill: this.formItem.adept,
      //           DocPosition: this.formItem.position,
      //           Province: this.formItem.province,
      //           City: this.formItem.city,
      //           Address: this.formItem.street,
      //           VocQFCode: this.formItem.professional?this.formItem.professional:"",
      //           VocQFCodeUrl: JSON.stringify(this.imgList2),
      //           DocQFCode: this.formItem.physicians?this.formItem.physicians:"",
      //           DocQFUrl: JSON.stringify(this.imgList1),
      //           DocType: "基层",
      //           Status: "1",
      //           Role:"医生",
      //           RoleID:"1",
      //           HealthOrgID: this.hospitalList[0]?this.hospitalList[0].ID:"",
      //           DeptID: this.formItem.deptID,
      //           HospitalName: this.formItem.hospital,
      //           ID: this.formItem.ID,
      //           CenterID: this.centerID,
      //           CenterName: this.centerTeam,
      //               DepartmentName:this.formItem.department,
      //               DepartmentID:this.formItem.deptID,
      //         }
      //       ).then((res) => {
      //         if (res.code == 200) {
      //           // console.log(res);
      //           content.scrollIntoView();
      //           this.$Message.success("成功！");
      //           window.localStorage.setItem("UserJid", res.data.UserJid);
      //           this.sUserJID = res.data.UserJid;
      //          this.getDocDatas(res.data.UserJid);
                
                
      //         } else if (res.code == 300) {
      //           if (res.message) {
      //             this.$Message.info(res.message);
      //           } else {
      //             this.$Message.info("请正确填写每一项！");
      //           }
      //         }
      //       });
      //       }
      //         return
                this.ismessageCode();
              
    },
    cancleTeam() {
      this.modal1 = false;
    },
    cancle() {
      // this.$Message.info("已取消！");
      this.$router.replace("/LoginPage");
    },
    //========================================医院的方法========================================================================
    searchHospital(val) {
      this.getHospitalDatas(val);
    },
    selected(i) {
      // console.log(i);
      this.getDepartmentDatas(i.label);
    },
    //========================================科室的方法========================================================================
  },

  computed: {},
  watch: {},
};
</script>
<style lang="less">
   .disclaimer{
      user-select:none;
      .ivu-checkbox{
        margin-right: 7px;
      }
    .ivu-checkbox-inner{
      border-radius: 50%;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner:after{
          border: 1px solid #17233d;
          border-top: 0;
          border-left: 0;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner{
          border-color: #dcdee2;
          background-color: transparent;
    }
    .ivu-checkbox-focus{
      box-shadow: none;
    }
  }

.personal {
  padding: 30px;
  width: 100%;
  background: #fff;
  .ivu-btn-primary {
    // background-color: rgba(0, 51, 102, 0.466666666666667);
    // border: none;
    font-size: 16px;
  }
  .head_img {
    height: 150px;
    margin-left: 40px;
  }
  .head_img img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
  }
  .physiciansimg {
    position: relative;
    display: inline-block;
    width: 104px;
    height: 104px;
    text-align: center;
    line-height: 104px;
    border: 1px solid transparent;
    border-radius: 4px;
    background: #fff;
    border: 1px solid rgba(216, 216, 216, 1);
    img {
      width: 96px;
      height: 51px;
    }
    .imgbot {
      top: 30px;
      left: 15px;
      width: 80px;
      height: 60px;
      position: absolute;
      cursor: pointer;
    }
    .ivu-poptip-popper {
      top: -120px !important;
      left: 30px !important;
    }
    .ivu-poptip-confirm .ivu-poptip-body .ivu-icon {
      position: relative !important;
    }
  }
  div {
    .professionalimg {
      position: relative;
      display: inline-block;
      width: 104px;
      height: 104px;
      text-align: center;
      line-height: 104px;
      border: 1px solid transparent;
      border-radius: 4px;
      background: #fff;
      border: 1px solid rgba(216, 216, 216, 1);

      img {
        width: 96px;
        height: 51px;
      }
      .imgbot1 {
        top: 30px;
        left: 15px;
        width: 80px;
        height: 60px;
        position: absolute;
        cursor: pointer;
      }

      .ivu-poptip-popper {
        top: -120px !important;
        left: 30px !important;
      }
      .ivu-poptip-confirm .ivu-poptip-body .ivu-icon {
        position: relative !important;
      }
    }
  }
  .submit {
    margin-top: 20px;
    margin-left: 20px;
    width: 69px;
    height: 40px;
    background-color: rgba(24, 144, 255, 1) !important;
  }
  .ivu-select-input{

  }
  // input:-webkit-autofill {
  // box-shadow: 0 0 0px 1000px white inset;
  // -webkit-box-shadow: 0 0 0px 1000px white inset;
  // }
}
</style>